import { MetadataStatus } from "datasets/pages/tables/types/enums/metadata";
import { GeneratedMetadata } from "datasets/pages/tables/types/interfaces/ingest";
import queryString from "query-string";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const useGeneratedMetadata = (fileKey: string) => {
  const tableQueryString = queryString.stringify({
    platform_storage_key: fileKey,
  });

  const url = fileKey ? `${VITE_CATALOG_API}/metadata?${tableQueryString}` : null;

  return useFetcher<GeneratedMetadata>(url, {
    refreshInterval: (latestData?: GeneratedMetadata) => {
      const metadataStatusPending =
        latestData &&
        [MetadataStatus.IN_PROGRESS, MetadataStatus.PENDING].includes(latestData.status);
      return metadataStatusPending ? 1000 : 0;
    },
  });
};

export default useGeneratedMetadata;
